import React from "react";
import { withRouter } from 'react-router-dom';
import { Container, Header, Grid, Image, List, Segment, Table } from "semantic-ui-react";
import imacImage from "../../semantic/dist/themes/fibrestream/assets/images/imac.png";
import BuidingsListModal from './BuidingsListModal';
import { connect } from "react-redux";
import { getBuildings } from "../../store/actions/buildings-by-service-available";
import { setTitle, setMetaDescription } from '../../util';

class Internet extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      buildingListModal: false
    };
    this.closeBuildingListModal = this.closeBuildingListModal.bind(this);
    this.openBuildingListModal = this.openBuildingListModal.bind(this);
  }

  componentDidMount() {
    document.title = setTitle(this.props.title);
    setMetaDescription(this.props.description);
    document.querySelector('body').classList.add('bg--black');
  }

  componentWillUnmount() {
    document.querySelector('body').classList.remove('bg--black');
  }


  openBuildingListModal(e) {
    e.preventDefault();

    this.props.getBuildings('FIBRE5000');
    this.setState({
      buildingListModal: true
    });
  }

  closeBuildingListModal() {

    this.setState({
      buildingListModal: false
    });
  }

  render() {
    const { buildingListModal } = this.state;
    const { buildings } = this.props;
    return (
      <Segment className="space internet" inverted vertical>
        <Header className="display-1 itc-mdbold text-uc" textAlign='center'>FAST JUST GOT CRAZY FAST</Header>
        <Container>
          <Grid className="" divided='vertically' stackable reversed='computer tablet'>

            <Grid.Column computer={7} tablet={8} mobile={16} floated='right'>
              <div className="pos-relative system">
                <Image src={imacImage} />
              </div>
            </Grid.Column>
            <Grid.Column computer={6} tablet={8} mobile={16} floated='left'>
              <Header as='h3' className="title text-uc f-size--18" inverted>INTRODUCING 5000 MBPS INTERNET</Header>
              <div className="text-grey7">
                <p>The fastest residential Internet service in Canada is now available in select buildings. Service includes:</p>
                {/* <p className="">Available at these locations:</p> */}
                <List bulleted>
                  <List.Item>5000 Mbps download speed</List.Item>
                  <List.Item>5000 Mbps upload speed</List.Item>
                  <List.Item>Unlimited data usage</List.Item>
                  <List.Item>Use your own multi-gig hardware*</List.Item>
                </List>
                {/* <p className="">Want Fibre7500 in your building?</p> */}
              </div>
              <a className="ui secondary button text-prime medium" onClick={this.openBuildingListModal}>VIEW AVAILABILITY</a>
              <p className="text-grey2 mt-7 text__recommended">*Recommended hardware: Linksys MR7500 (AXE6600)</p>
            </Grid.Column>
          </Grid>

          <section className="system-requirements">
            <Header as='h1' className='itc-std-md normal' textAlign='center' inverted>System requirements</Header>
            <Grid centered>
              <Grid.Column className="py-0">
                <Table basic='very' celled inverted unstackable >
                  <Table.Body>
                    <Table.Row verticalAlign='top'>
                      <Table.Cell>
                        <Header as='h4' inverted>
                          Network Adapter
                      </Header>
                      </Table.Cell>
                      <Table.Cell>Multi-gigabit Ethernet (5GBASE-T)</Table.Cell>
                    </Table.Row>
                    <Table.Row verticalAlign='top'>
                      <Table.Cell>
                        <Header as='h4' inverted>
                          Processor
                      </Header>
                      </Table.Cell>
                      <Table.Cell>Intel i5 3.2GHz or higher or AMD FX-8120 or higher</Table.Cell>
                    </Table.Row>
                    <Table.Row verticalAlign='top'>
                      <Table.Cell>
                        <Header as='h4' inverted>
                          Memory
                      </Header>
                      </Table.Cell>
                      <Table.Cell>8 GB RAM or higher</Table.Cell>
                    </Table.Row>
                    <Table.Row verticalAlign='top'>
                      <Table.Cell>
                        <Header as='h4' inverted>
                          Hard Drive
                      </Header>
                      </Table.Cell>
                      <Table.Cell>PCIx SSD with sequential read/write over 1.25 Gigabytes per second</Table.Cell>
                    </Table.Row>
                    <Table.Row verticalAlign='top'>
                      <Table.Cell>
                        <Header as='h4' inverted>
                          Operating System
                      </Header>
                      </Table.Cell>
                      <Table.Cell>Windows 8.1 or later (PC) or macOS 10.8 or later (Mac)</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Grid.Column>
            </Grid>
          </section>
        </Container>

        <BuidingsListModal open={buildings && buildingListModal} closeModal={this.closeBuildingListModal} />
      </Segment>
    )
  }
}

const mapStateToProps = state => {
  return {
    buildings: state.buildingsByServiceAvailable
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getBuildings: code => dispatch(getBuildings(code)),

  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Internet)
);



// WEBPACK FOOTER //
// ./src/components/internet/Internet.js